import axios from "axios";

//'http://127.0.0.1:8000/
//https://api-test.antesala.com.ar/public/api

const url = process.env.REACT_APP_API_PUBLIC_URL;


let apiPrivateAntesala = axios.create({
  baseURL: url
});

//apiPrivateAntesala.defaults.headers.common["Content-Type"] = "application/json";

apiPrivateAntesala.interceptors.request.use(function (config) {
  const token = localStorage.getItem("token_api");
  config.headers.Authorization = token ? `Bearer ${token}` : ``;

  return config;
});

export default apiPrivateAntesala;